export const TABLET_WIDTH = 768;
